import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { RootState } from '@/redux/store/configureStore'

import { getEmiPrice } from '@/api/srp/emi'

const initialState = {
  emiCalloutMsg: {
    loading: false,
    loaded: false,
    data: {},
  },
  emiData: {
    error: false,
    isLoading: false,
  },
  rtEmiData: {
    error: false,
    isLoading: false,
    data: {},
  },
}

export const fetchEmiEligibilityData = createAsyncThunk('emiEligibility/eligibility', async data => {
  const response = await getEmiPrice(data?.payload)
  return response
})

export const emiEligibilitySlice = createSlice({
  name: 'emiEligibility',
  initialState,
  reducers: {
    setEmiCalloutMsg: (state, action) => {
      state.emiCalloutMsg = action?.payload
    },
    setEmiData: (state, action) => {
      state.emiData = action?.payload
    },
    setRtEmiData: (state, action) => {
      state.rtEmiData = action?.payload
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchEmiEligibilityData.pending, (state, action) => {
      const { meta: { arg = {} } = {} } = action || {}
      if (arg.type === 'emiCallout') {
        state.emiCalloutMsg.loading = true
      } else if (arg.type === 'emiRtPrice') {
        state.rtEmiData.isLoading = true
      } else {
        const { finalDataObj } = arg
        state.emiData = {
          ...state.emiData,
          ...finalDataObj?.['regular'],
        }
      }
    })
    builder.addCase(fetchEmiEligibilityData.fulfilled, (state, action) => {
      const { meta: { arg = {} } = {} } = action || {}
      if (arg.type === 'emiCallout') {
        handleEmiCallout(state, action)
      } else if (arg.type === 'emiRtPrice') {
        handleRtEmiPrice(state, action)
      } else {
        hadleOwTupleEmiPrice(state, action)
      }
    })
    builder.addCase(fetchEmiEligibilityData.rejected, (state, action) => {
      const { meta: { arg: { type = '' } = {} } = {} } = action || {}
      if (type === 'emiRtPrice') {
        state.rtEmiData = {
          error: true,
          isLoading: false,
          data: {},
        }
      } else {
    
          state.emiCalloutMsg= {
            loading: false,
            loaded: false,
            data: {},
          }
          state.emiData= {
            error: true,
            isLoading: false,
          }
        
      }
    })
  },
})

const handleEmiCallout = (state, action) => {
  if (
    action.payload &&
    action.payload.data &&
    action.payload.data.data &&
    action.payload.data.data.call_out_attributes &&
    action.payload.data.data.call_out_attributes[0]
  ) {
    state.emiCalloutMsg = {
      loading: false,
      loaded: true,
      data: action.payload.data.data,
    }
  } else {
    state.emiCalloutMsg = {
      loading: false,
      loaded: false,
      data: {},
    }
  }
}

const handleRtEmiPrice = (state, action) => {
  if (action?.payload?.data?.flight_list) {
    state.rtEmiData ={
      error: false,
      isLoading: false,
      data: action?.payload?.data?.flight_list[0]
    }
  } else {
    state.rtEmiData = {
      error: true,
      isLoading: false,
      data: {},
    }
  }
}

const hadleOwTupleEmiPrice = (state, action) => {
  const { meta: { arg = {} } = {} } = action || {}
  if (action.payload && action.payload.data && action.payload.data.flight_list) {
    const flightList = action.payload.data.flight_list
    const type = 'regular'
    let index = 0
    const dataObj = {}
    const { finalUuidList } = arg
    finalUuidList?.[type]?.forEach((item = {}) => {
      if (item.uuid === (flightList[index] && flightList[index].uuid)) {
        dataObj[item.id] = {
          isLoading: false,
          ...flightList[index],
        }
      } else {
        dataObj[item.id] = {}
      }
      index += 1
    })
    state.emiData = {
      ...state.emiData,
      error: false,
      ...dataObj,
    }
  } else {
    state.emiData = {
      error: true,
      isLoading: false,
    }
  }
}

const getEmiCalloutMsg = (state: RootState) => state.emiEligibility.emiCalloutMsg

const getEmiData = (state: RootState) => state.emiEligibility.emiData

const getHighRpsEmiData = (state: RootState) => state.emiEligibility.highRpsData

const getMevcEmiData = (state: RootState) => state.emiEligibility.mevcData

const getMevcAirportEmiData = (state: RootState) => state.emiEligibility.mevcAirportData

const getSplFareEmiData = (state: RootState) => state.emiEligibility.splFareData

const getRtEmiData = (state: RootState) => state.emiEligibility.rtEmiData

const { reducer, actions } = emiEligibilitySlice

const { setEmiData, setEmiCalloutMsg, setRtEmiData, setHighRpsEmi, setMevcEmi, setMevcAirportEmi, setSplFareEmi } =
  actions

export {
  getEmiCalloutMsg,
  getEmiData,
  getHighRpsEmiData,
  getMevcEmiData,
  getMevcAirportEmiData,
  getSplFareEmiData,
  getRtEmiData,
  setEmiData,
  setRtEmiData,
  setEmiCalloutMsg,
  setHighRpsEmi,
  setMevcEmi,
  setMevcAirportEmi,
  setSplFareEmi,
}

export default reducer
